import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Subject } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { AppSessionStorage } from '../../../services/storage/app.session-storage';

/**
 * Checks whether the user has access to the current page.
 */
@Injectable()
export class AuthGuard {
    loadingStartedSub = new Subject<void>();
    loadingFinishedSub = new Subject<boolean>();

    canActivate: CanActivateFn = () => {
        this.loadingStartedSub.next();
        const authService = inject(AuthService);
        const appSessionStorage = inject(AppSessionStorage);

        return authService.requireUserToBeLoggedIn().pipe(
            map(isLoggedIn => {
                if (!isLoggedIn) {
                    appSessionStorage.saveNotLoggedRedirectUrl(window.location.href);
                    authService.logout();

                    return false;
                }

                return true;
            }),
            finalize(() => this.loadingFinishedSub.next(true))
        );
    };
}
